import {BaseModelMicroService} from './base-model-micro-service';

export class UserRoleRef extends BaseModelMicroService{
    name: string;
}
